import cx from 'classnames';

import { FORM_STEP, FORM_SUBMIT } from 'constants/widgetTypes';
import { BUTTON } from 'constants/widgetTypes';
import { TEXT, FORM_FIELD } from 'constants/widgetTypes';
import { FORM } from 'constants/widgetTypes';
import styles from './palette.module.scss';

const production = process.env.NODE_ENV === 'production';
const imageId = production ? "62e3ab81dbfd3e6ec4a2a133" : "62de5538833d8a337666b497";

export const forms = [
  {
    id: 'basic_Form',
    name: 'Basic Form',
    render: () => {
      return <img className={cx(styles.form, styles.basic)} src="/images/palette/form/basic.png" />
    },
    data: {
      type: FORM,
      name: "Form",
      properties: {
        "desktop": {
          "visible": true,
          "layout": {
            "transform": {
              "translate": `0px, 0px`,
              "rotate": "0deg"
            },
            "width": "600px",
            "height": "415px"
          },
          "border": null,
          "background": {
            "type": "solid",
            "r": 245,
            "g": 245,
            "b": 245,
            "a": 1
          },
          "formEmailTemplate": null
        },
        "mobile": {
          "visible": true,
          "layout": {
            "transform": {
              "translate": `0px, 0px`,
              "rotate": "0deg"
            },
            "width": "335px",
            "height": "463px"
          },
          "border": null,
          "background": null,
          "formEmailTemplate": null
        }
      },
      content: null,
      widgets: [{
        type: FORM_STEP,
        name: "Form",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": null,
              "height": null
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": null,
              "height": null
            }
          }
        },
        widgets: [{
          type: TEXT,
          name: "Form Title",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "30px,30px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "auto",
                "height": "auto"
              },
              "fontSize": "16",
              "lineSpacing": "1.2",
              "letterSpacing": "0",
              "color": null,
              "alignment": "left",
              "animation": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "20px,20px",
                  "rotate": "0deg"
                },
                "width": "233.875px",
                "height": "auto"
              },
              "fontSize": "32",
              "lineSpacing": "1.2",
              "letterSpacing": "0",
              "color": null,
              "alignment": "left",
              "animation": null
            }
          },
          content: '<h3>Get in touch</h3>'
        },
        {
          type: FORM_FIELD,
          name: "First Name",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "30px,96px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "255px",
                "height": "auto"
              },
              "field": "firstname",
              "label": "First Name",
              "placeholder": "Enter first name",
              "workEmail": false,
              "mandatory": false,
              "styles": {
                "layout": {
                  "alignment": "left",
                  "labelPadding": "0",
                  "inputPadding": "12",
                  "fieldSpacing": "2",
                  "regular": null
                },
                "regular": {
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "width": "2",
                    "radius": null,
                    "style": "bottom"
                  },
                  "label": {
                    "background": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "placeholderColor": null,
                    "font": {
                      "style": null,
                      "fontSize": "12",
                      "fontFamily": "Montserrat,sans-serif",
                      "lineSpacing": null,
                      "letterSpacing": null,
                      "color": null
                    }
                  },
                  "input": {
                    "background": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "placeholderColor": {
                      "type": "solid",
                      "r": 213,
                      "g": 213,
                      "b": 213,
                      "a": 1
                    },
                    "font": {
                      "style": null,
                      "fontSize": "14",
                      "fontFamily": "Montserrat,sans-serif",
                      "lineSpacing": null,
                      "letterSpacing": null,
                      "color": null
                    }
                  }
                }
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "19px,78.484375px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "295px",
                "height": "auto"
              },
              "field": null,
              "label": null,
              "placeholder": null,
              "workEmail": false,
              "mandatory": false,
              "styles": null
            }
          }
        },
        {
          type: FORM_FIELD,
          name: "Last Name",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "310px,96px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "255px",
                "height": "auto"
              },
              "field": "lastname",
              "label": "Last Name",
              "placeholder": "Enter last name",
              "workEmail": false,
              "mandatory": false,
              "styles": {
                "layout": {
                  "alignment": "left",
                  "labelPadding": "0",
                  "inputPadding": "12",
                  "fieldSpacing": "2",
                  "regular": null
                },
                "regular": {
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "width": "2",
                    "radius": null,
                    "style": "bottom"
                  },
                  "label": {
                    "background": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "placeholderColor": null,
                    "font": {
                      "style": null,
                      "fontSize": "12",
                      "fontFamily": "Montserrat,sans-serif",
                      "lineSpacing": null,
                      "letterSpacing": null,
                      "color": null
                    }
                  },
                  "input": {
                    "background": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "placeholderColor": {
                      "type": "solid",
                      "r": 213,
                      "g": 213,
                      "b": 213,
                      "a": 1
                    },
                    "font": {
                      "style": null,
                      "fontSize": "14",
                      "fontFamily": "Montserrat,sans-serif",
                      "lineSpacing": null,
                      "letterSpacing": null,
                      "color": null
                    }
                  }
                }
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "19px,159.50037499999996px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "295px",
                "height": "auto"
              },
              "field": null,
              "label": null,
              "placeholder": null,
              "workEmail": false,
              "mandatory": false,
              "styles": null
            }
          }
        },
        {
          type: FORM_FIELD,
          name: "Email",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "30px,179px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "540px",
                "height": "auto"
              },
              "field": "email",
              "label": "Email",
              "placeholder": "Enter email address",
              "workEmail": true,
              "mandatory": true,
              "styles": {
                "layout": {
                  "alignment": "left",
                  "labelPadding": "0",
                  "inputPadding": "12",
                  "fieldSpacing": "2",
                  "regular": null
                },
                "regular": {
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "width": "2",
                    "radius": null,
                    "style": "bottom"
                  },
                  "label": {
                    "background": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "placeholderColor": null,
                    "font": {
                      "style": null,
                      "fontSize": "12",
                      "fontFamily": "Montserrat,sans-serif",
                      "lineSpacing": null,
                      "letterSpacing": null,
                      "color": null
                    }
                  },
                  "input": {
                    "background": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "placeholderColor": {
                      "type": "solid",
                      "r": 213,
                      "g": 213,
                      "b": 213,
                      "a": 1
                    },
                    "font": {
                      "style": null,
                      "fontSize": "14",
                      "fontFamily": "Montserrat,sans-serif",
                      "lineSpacing": null,
                      "letterSpacing": null,
                      "color": null
                    }
                  }
                }
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "19px,240.51673242187496px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "295px",
                "height": "auto"
              },
              "field": null,
              "label": null,
              "placeholder": null,
              "workEmail": false,
              "mandatory": false,
              "styles": null
            }
          }
        },
        {
          type: FORM_FIELD,
          name: "Company",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "30px,262px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "540px",
                "height": "auto"
              },
              "field": "company",
              "label": "Company",
              "placeholder": "Enter company",
              "workEmail": false,
              "mandatory": false,
              "styles": {
                "layout": {
                  "alignment": "left",
                  "labelPadding": "0",
                  "inputPadding": "12",
                  "fieldSpacing": "2",
                  "regular": null
                },
                "regular": {
                  "border": {
                    "sides": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "width": "2",
                    "radius": null,
                    "style": "bottom"
                  },
                  "label": {
                    "background": null,
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "placeholderColor": null,
                    "font": {
                      "style": null,
                      "fontSize": "12",
                      "fontFamily": "Montserrat,sans-serif",
                      "lineSpacing": null,
                      "letterSpacing": null,
                      "color": null
                    }
                  },
                  "input": {
                    "background": {
                      "type": "solid",
                      "r": 255,
                      "g": 255,
                      "b": 255,
                      "a": 1
                    },
                    "color": {
                      "type": "solid",
                      "r": 0,
                      "g": 0,
                      "b": 0,
                      "a": 1
                    },
                    "placeholderColor": {
                      "type": "solid",
                      "r": 213,
                      "g": 213,
                      "b": 213,
                      "a": 1
                    },
                    "font": {
                      "style": null,
                      "fontSize": "14",
                      "fontFamily": "Montserrat,sans-serif",
                      "lineSpacing": null,
                      "letterSpacing": null,
                      "color": null
                    }
                  }
                }
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "18.5px,321.5328134765624px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "295px",
                "height": "auto"
              },
              "field": null,
              "label": null,
              "placeholder": null,
              "workEmail": false,
              "mandatory": false,
              "styles": null
            }
          }
        },
        {
          type: FORM_SUBMIT,
          name: "Submit Button",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "30px,345px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "200px",
                "height": "40px"
              },
              "regular": {
                "font": {
                  "style": {
                    "bold": false,
                    "italic": false,
                    "underline": false
                  },
                  "fontSize": "14",
                  "fontFamily": null,
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": {
                    "type": "solid",
                    "r": 0,
                    "g": 0,
                    "b": 0,
                    "a": 1
                  }
                },
                "background": {
                  "type": "solid",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                },
                "border": {
                  "sides": null,
                  "color": null,
                  "width": "0",
                  "radius": {
                    "lock": true,
                    "topLeft": "20",
                    "topRight": "20",
                    "bottomLeft": "20",
                    "bottomRight": "20"
                  }
                },
                "shadow": null
              },
              "hover": {
                "font": {
                  "style": null,
                  "fontSize": null,
                  "fontFamily": null,
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": {
                    "type": "solid",
                    "r": 0,
                    "g": 0,
                    "b": 0,
                    "a": 1
                  }
                },
                "background": {
                  "type": "solid",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                },
                "border": null,
                "shadow": null
              },
              "alignment": null,
              "animation": null
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "19px,402.4998134765624px",
                  "rotate": "0deg",
                  "scale": "1,1"
                },
                "width": "200px",
                "height": "40px"
              },
              "regular": {
                "font": {
                  "style": null,
                  "fontSize": "14",
                  "fontFamily": null,
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": null
                },
                "background": null,
                "border": null,
                "shadow": null
              },
              "hover": {
                "font": {
                  "style": null,
                  "fontSize": null,
                  "fontFamily": null,
                  "lineSpacing": null,
                  "letterSpacing": null,
                  "color": null
                },
                "background": null,
                "border": null,
                "shadow": null
              },
              "alignment": null,
              "animation": null
            }
          },
          content: "Submit"
        }]
      },
      {
        type: FORM_STEP,
        name: "Success",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": null,
              "height": null
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": null,
              "height": null
            }
          }
        },
        widgets: [
          {
            type: TEXT,
            name: "Form Title",
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "30px,268px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "353.461px",
                  "height": "auto"
                },
                "fontSize": "16",
                "lineSpacing": "1.2",
                "letterSpacing": "0",
                "color": null,
                "alignment": "left",
                "animation": null
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "20px,336.00048828125px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "261px",
                  "height": "auto"
                },
                "fontSize": "32",
                "lineSpacing": "1.2",
                "letterSpacing": "0",
                "color": null,
                "alignment": "left",
                "animation": null
              }
            },
            content: '<h3><strong>Thanks </strong></h3>\n<h3><strong>for submitting!</strong></h3>'
          }, {
            type: TEXT,
            name: "Form Title",
            properties: {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "30px, 360px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "auto",
                  "height": "auto"
                },
                "fontSize": "16",
                "lineSpacing": "1.2",
                "letterSpacing": "0",
                "color": null,
                "alignment": "left",
                "animation": null
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "20px, 415px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "238.4921875px",
                  "height": "auto"
                },
                "fontSize": "16",
                "lineSpacing": "1.2",
                "letterSpacing": "0",
                "color": null,
                "alignment": "left",
                "animation": null
              }
            },
            content: '<p>We’ll get back to you shortly :)</p>'
          },
          {
            "type": "cleverstory.v2.widgets.image",
            "name": "Image",
            "capabilities": null,
            "order": 1,
            "fonts": null,
            "actions": null,
            "properties": {
              "desktop": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "198.0000000000001px,48.99999999999969px",
                    "rotate": "0deg",
                    "scale": "1,1"
                  },
                  "width": "317px",
                  "height": "274.961px"
                },
                "crop": null,
                "alt": null,
                "animation": null,
                "border": null,
                "position": null,
                "shadow": null
              },
              "mobile": {
                "visible": true,
                "layout": {
                  "transform": {
                    "translate": "20px,20px",
                    "rotate": "0deg"
                  },
                  "width": "295px",
                  "height": "256.0584635416667px"
                },
                "crop": null,
                "alt": null,
                "animation": null,
                "border": null,
                "position": null,
                "shadow": null
              }
            },
            "content": {
              "id": imageId,
              "contentType": "image/png",
              "type": "image",
              "width": 500.0,
              "height": 434.0,
              "url": `public/cleverstory/v2/media/images/${imageId}/thankyou.png`
            }
          },
        ]
      }]
    }
  }
]